<template>
  <div>
    <ui-modal
      ref="modal"
      :title="`Información de Booking por Aceptar - Cliente ${empresaModel} - Booking ID: ${idBookingModel}`"
      @close="actionSetVisibleModalInformacionGeneral(false)"
      size="auto"
    >
      <div v-if="load" class="w-100">
        <Loading />
      </div>
      <div v-else>
        <!-- Informacion Relevante a la ruta -->
        <fieldset-component
          texto="Informacion Relevante a la Ruta"
          bold
          class="mb-3"
        />
        <!-- Primera Fila -->
        <div class="d-flex">
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Estado</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2">{{ estadoModel ? estadoModel : "Sin definir" }}</p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Año</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2" v-text="anioModel"></p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Semana</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2" v-text="semanaModel"></p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Empresa</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2" v-text="empresaModel"></p>
            </div>
          </div>
        </div>
        <!-- Segunda Fila -->
        <div class="d-flex">
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Puerto de Origen</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2">{{ origenModel ? origenModel : "Sin definir" }}</p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Puerto de Carga</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2">{{ polModel ? polModel : "Sin definir" }}</p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Puerto de Descarga</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2" v-text="podModel"></p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Puerto de Destino</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2">
                {{ destinoModel ? destinoModel : "Sin definir" }}
              </p>
            </div>
          </div>
        </div>
        <!-- Tercera Fila -->
        <div class="d-flex">
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Nave</p>
            </div>
            <div class="d-flex justify-content-center Cell">
              <p class="m-2">{{ naveModel ? naveModel : "Sin definir" }}</p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Viaje</p>
            </div>
            <div class="d-flex justify-content-center Cell">
              <p class="m-2">{{ viajeModel ? viajeModel : "Sin definir" }}</p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">¿Transporte Terrestre?</p>
            </div>
            <div class="d-flex justify-content-center Cell">
              <p class="m-2">
                {{ terrestreModel ? terrestreModel : "Sin definir" }}
              </p>
            </div>
          </div>
        </div>
        <!-- Informacion relevante al camionaje -->

        <fieldset-component
          texto="Informacion relevante al camionaje"
          bold
          class="mb-3 mt-3"
        />
        <!-- Cuarta Fila -->
        <div class="d-flex">
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Tipo Movimiento</p>
            </div>
            <div class="d-flex justify-content-center Cell">
              <p class="m-2">
                {{ tipoMovimientoModel ? tipoMovimientoModel : "Sin definir" }}
              </p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Costo camionaje</p>
            </div>
            <div class="d-flex justify-content-center Cell">
              <p class="m-2">
                {{ camionajeModel ? camionajeModel : "Sin definir" }}
              </p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Tipo de Transporte</p>
            </div>
            <div class="d-flex justify-content-center Cell">
              <p class="m-2">
                {{ tipoTransporteModel ? tipoTransporteModel : "Sin definir" }}
              </p>
            </div>
          </div>
        </div>
        <!-- Informacion relevante a Shipper -->
        <fieldset-component
          texto="Informacion relevante a Shipper"
          bold
          class="mb-3 mt-3"
        />
        <!-- Quinta Fila -->
        <div class="d-flex">
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Shipper</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2" v-text="shipperModel"></p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Direccion Shipper</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2">
                {{
                  direccionShipperModel ? direccionShipperModel : "Sin definir"
                }}
              </p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Consignatario</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2" v-text="consignatarioModel"></p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Notificado</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2">
                {{ notificadoModel ? notificadoModel : "Sin definir" }}
              </p>
            </div>
          </div>
        </div>

        <!-- Informacion Relevante a la Carga -->

        <!-- Sexta Fila -->
        <div class="d-flex">
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Contenedor</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2">
                {{ contenedorModel ? contenedorModel : "Sin definir" }}
              </p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Producto a exportar</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2" v-text="productoModel"></p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Cantidad de Contenedores</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2">
                {{
                  cantContenedoresModel ? cantContenedoresModel : "Sin definir"
                }}
              </p>
            </div>
          </div>
        </div>
        <!-- Septima Fila -->
        <div class="d-flex">
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Temperatura °C</p>
            </div>
            <div class="d-flex justify-content-center Cell">
              <p class="m-2">
                {{ temperaturaModel ? temperaturaModel : "Sin definir" }}
              </p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">% Ventilacion</p>
            </div>
            <div class="d-flex justify-content-center Cell">
              <p class="m-2">
                {{ ventilacionModel ? ventilacionModel : "Sin definir" }}
              </p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">% Ventilacion en CBM</p>
            </div>
            <div class="d-flex justify-content-center Cell">
              <p class="m-2">
                {{ ventilacionCBMModel ? ventilacionCBMModel : "Sin definir" }}
              </p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">¿Cold Treatment?</p>
            </div>
            <div class="d-flex justify-content-center Cell">
              <p class="m-2">
                {{ coldTreatmentModel ? coldTreatmentModel : "Sin definir" }}
              </p>
            </div>
          </div>
        </div>
        <!-- Otros -->
        <fieldset-component texto="Otros" bold class="mt-3 mb-3" />
        <!-- Octava Fila -->
        <div class="d-flex">
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Emision de BL</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2">{{ bLModel ? bLModel : "Sin definir" }}</p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Uso de genset de la Naviera</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2" v-text="gensetModel"></p>
            </div>
          </div>
        </div>
        <!-- Novena Fila -->
        <div class="d-flex">
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Forma de Pago</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2">{{ pagoModel ? pagoModel : "Sin definir" }}</p>
            </div>
          </div>
          <div class="w-50">
            <div class="Heading Cell">
              <p class="m-2">Contrato</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2">
                {{ contratoModel ? contratoModel : "Sin definir" }}
              </p>
            </div>
          </div>
        </div>
        <!-- Decima Fila -->
        <div class="d-flex">
          <div class="w-100">
            <div class="Heading Cell">
              <p class="m-2">Comentarios</p>
            </div>
            <div class="d-flex justify-content-center Cell h-100">
              <p class="m-2" v-text="comentarioModel"></p>
            </div>
          </div>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// UI Modal
import UiModal from "keen-ui/src/UiModal";
// Vuex
import { mapState, mapActions } from "vuex";
// Common
import FieldsetComponent from "../../../../common/FieldsetComponent";
import Loading from "../../../../common/loading.vue";

export default {
  props: ["data", "dataVer", "load"],
  data() {
    return {
      idBookingModel: "",
      estadoModel: "",
      anioModel: "",
      semanaModel: "",
      empresaModel: "",
      origenModel: "",
      polModel: "",
      podModel: "",
      destinoModel: "",
      naveModel: "",
      viajeModel: "",
      terrestreModel: "",
      tipoMovimientoModel: "",
      camionajeModel: "",
      tipoTransporteModel: "",
      shipperModel: "",
      direccionShipperModel: "",
      consignatarioModel: "",
      notificadoModel: "",
      contenedorModel: "",
      productoModel: "",
      cantContenedoresModel: "",
      temperaturaModel: "",
      ventilacionModel: "",
      ventilacionCBMModel: "",
      coldTreatmentModel: "",
      bLModel: "",
      gensetModel: "",
      pagoModel: "",
      contratoModel: "",
      comentarioModel: "",
    };
  },
  components: {
    UiModal,
    FieldsetComponent,
    Loading,
  },
  computed: {
    ...mapState("lineas", ["visibleModalInformacionGeneral"]),
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetVisibleModalInformacionGeneral",
      // "actionSetIdAuxiliarBookingSeleccionado",
    ]),

    openModal(ref) {
      this.$refs[ref].open();
    },

    closeModal(ref) {
      this.$refs[ref].close();
    },
  },
  watch: {
    visibleModalInformacionGeneral: function (_new) {
      _new && this.openModal("modal");
    },
    data: function (_new) {
      // console.log(_new);

      this.idBookingModel = _new.data[0];

      this.anioModel = _new.data[1];
      this.semanaModel = _new.data[2];
      this.empresaModel = _new.data[3];
      this.podModel = _new.data[5];
      this.shipperModel = _new.data[4];
      this.consignatarioModel = _new.data[6];
      this.productoModel = _new.data[8];
      this.gensetModel = _new.data[10];
      this.comentarioModel = _new.data[11];
    },
    dataVer: function (_new) {
      // console.log(_new);

      this.estadoModel = _new.estado;
      this.origenModel = _new.puerto_origen;
      this.polModel = _new.pol;
      this.destinoModel = _new.destino_final;
      this.naveModel = _new.nave;
      this.viajeModel = _new.viaje;
      this.terrestreModel = _new.transporte_terrestre;
      this.tipoMovimientoModel = _new.tipo_movimiento;
      this.camionajeModel = _new.costo_camionaje;
      this.tipoTransporteModel = _new.tipo_transporte;
      this.direccionShipperModel = _new.shipper_address;
      this.notificadoModel = _new.notificado;
      this.contenedorModel = _new.equipo;
      this.cantContenedoresModel = _new.cant_containers_orig;
      this.temperaturaModel = _new.temperatura;
      this.ventilacionModel = _new.ventilacion;
      this.ventilacionCBMModel = _new.ventilacion_cbm;
      this.coldTreatmentModel = _new.cold_treatment;
      this.bLModel = _new.emision_bl;
      this.pagoModel = _new.payment_method_name;
      this.contratoModel = (_new.contrato) ? _new.contrato : 'Otros - ' + _new.contract_number;
    },
  },
};
</script>
<style>
.modal-informacion-ver-por-aceptar .ui-modal__container {
  width: 90% !important;
  margin-top: 70px !important;
}
/* .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
  width: 95% !important;
} */

.Heading {
  background-color: #ccccca;
  font-weight: bold;
  text-align: center;
}

.Cell {
  border: groove;
  border-width: thin;
}
</style>
